import { showLoader, hideLoader } from 'Shared/Loader';
import { Ajax } from 'components/Ajax';
import { ApiUrl } from 'project/Defines';
import { dispatchCustomEvent } from 'project/utilities';

import { message } from 'antd';
import FileSaver from 'file-saver';

const loaderName = 'TRANSLATION_FILE_UPLOAD_LOADER';
const exportLoaderName = 'TRANSLATION_FILE_EXPORT_LOADER';

export function TranslationImport(data, listUpdateEvent, successCallback) {
    showLoader(loaderName);

    Ajax.post({
        url: ApiUrl.SetupUITranslationsImport,
        data: {
            file: data && data.file
        },
        success: (response) => {
            if (!response.HasError) {
                successCallback && successCallback(response);
                dispatchCustomEvent(listUpdateEvent);
                hideLoader(loaderName);
            } else {
                message.error(response.message);
                hideLoader(loaderName);
            }
        }
    });
}

export function TranslationExport() {
    showLoader(exportLoaderName);

    Ajax.download({
        url: ApiUrl.SetupUITranslationsExport,
        data: {},
        //autoDownload: false,
        success: (blob) => {
            FileSaver.saveAs(blob, "Translation.xlsx");
            hideLoader(exportLoaderName);
        },
        error: () => {
            hideLoader(exportLoaderName);
        }
    });
}
